import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
const AssetsRow = _ref => {
  let onClick = _ref.onClick,
    propsID = _ref.id,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    index = _ref.index,
    isSelected = _ref.isSelected,
    onSelect = _ref.onSelect;
  const alias = data.alias,
    id = data.id,
    name = data.name;
  const handleClick = () => onClick(propsID);
  const handleSelect = onSelect.bind(this, id);
  let displayName = name;
  if (!displayName) {
    displayName = /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'lightgray'
      }
    }, "Asset without ID");
  }
  return /*#__PURE__*/React.createElement("tr", {
    style: {
      height: '30px'
    },
    className: "t-ar-".concat(index, " t-ar-name-").concat(kebabCase(name))
  }, /*#__PURE__*/React.createElement("td", {
    "aria-label": "select-asset-checkbox",
    style: {
      width: '1px',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "t-ar-check",
    type: "checkbox",
    checked: isSelected,
    onChange: handleSelect
  })), /*#__PURE__*/React.createElement("td", {
    className: "t-ar-".concat(index, "-name"),
    onClick: handleClick,
    onKeyPress: handleClick,
    role: "button"
  }, name), /*#__PURE__*/React.createElement("td", {
    onClick: handleClick,
    onKeyPress: handleClick,
    role: "button"
  }, alias));
};
AssetsRow.propTypes = {
  data: PropTypes.shape({
    alias: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string
  }),
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};
export default AssetsRow;